import { z } from 'zod';
import { MESES_CXC } from './cxc.js';
// Reportes de CxC (spec 2026-10-14-cxc-reportes-design.md). La query llega
// como texto: listas separadas por comas; una lista vacía cuenta como "sin filtro".
function lista(item) {
    return z.preprocess(v => {
        if (typeof v !== 'string')
            return v;
        const partes = v.split(',').map(s => s.trim()).filter(Boolean);
        return partes.length ? partes : undefined;
    }, z.array(item).optional());
}
export const reportesCxcQuerySchema = z
    .object({
    anios: lista(z.coerce.number().int().min(2020).max(2100)),
    meses: lista(z.enum(MESES_CXC)),
    clientes: lista(z.string().uuid()),
    iva: z.enum(['0', '1']).optional(),
    // #75: "Incluir adicionales" va marcado por defecto; adicionales=0 deja solo los fees de servicio.
    adicionales: z.enum(['0', '1']).optional(),
})
    .transform(({ iva, adicionales, ...resto }) => {
    const limpio = Object.fromEntries(Object.entries(resto).filter(([, v]) => v !== undefined));
    return { ...limpio, iva: iva === '1', adicionales: adicionales !== '0' };
});
export function indicePeriodoCxc(p) {
    return p.anio * 12 + MESES_CXC.indexOf(p.mes);
}
// Periodo por defecto de Reportes y de CxC (Moisés, 14-oct): el mes actual si
// tiene registros; si no, el último con registros que no sea futuro (en su
// defecto, el más reciente). `hoy` es YYYY-MM-DD en CDMX.
export function periodoPorDefectoCxc(periodos, hoy) {
    if (periodos.length === 0)
        return null;
    const [anio, mes] = hoy.split('-').map(Number);
    const actual = anio * 12 + (mes - 1);
    const indices = [...new Set(periodos.map(indicePeriodoCxc))];
    const pasados = indices.filter(i => i <= actual);
    const elegido = indices.includes(actual) ? actual : pasados.length ? Math.max(...pasados) : Math.max(...indices);
    return { anio: Math.floor(elegido / 12), mes: MESES_CXC[elegido % 12] };
}
//# sourceMappingURL=cxc-reportes.js.map